export default __webpack_public_path__ + "static/media/pepper.926d4b01.png";